import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="template-treatment-plan"
export default class extends Controller {
  static targets = ["notes", "templateSelect"]

  connect() {
    this.boundTrixInitialized = this.trixInitialized.bind(this)
    document.addEventListener("trix-initialize", this.boundTrixInitialized)
  }

  disconnect() {
    document.removeEventListener("trix-initialize", this.boundTrixInitialized)
  }

  trixInitialized(event) {
    if (this.notesTarget.contains(event.target)) {
      this.trixEditor = event.target
    }
  }

  async loadTemplate() {
    const templateId = this.templateSelectTarget.value
    if (!templateId) return

    try {
      const response = await get(
        `/student/templates/${templateId}/content`,
        { responseKind: "json" }
      )

      if (!response.ok) {
        console.error("error carga plantilla ", response.statusCode)
        return
      }

      const data = await response.json

      const editor = this.notesEditor()
      if (!editor?.editor) {
        console.error("editor trix no inicializado")
        return
      }

      const activeElement = document.activeElement
      editor.editor.loadHTML(data.content)
      this.restoreFocus(activeElement, editor)
    } catch (error) {
      console.error("error al cargar la plantilla:", error)
    }
  }

  notesEditor() {
    if (this.trixEditor) return this.trixEditor
    if (!this.hasNotesTarget) return null
    if (this.notesTarget.tagName === "TRIX-EDITOR") return this.notesTarget

    return this.notesTarget.querySelector("trix-editor")
  }

  restoreFocus(activeElement, editor) {
    if (!activeElement || activeElement === editor) return
    if (typeof activeElement.focus !== "function") return

    activeElement.focus()
    requestAnimationFrame(() => {
      if (document.activeElement === editor) activeElement.focus()
    })
  }
}
